import { Component } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { SchedulerRouterProps } from '../SchedulerRouterProps';
import { SchedulerEntities } from '../SchedulerEntities';
import { SchedulerLayout } from '../SchedulerLayout';
import UpcomintRuns from '../components/UpcomintRuns';

export interface SchedulerListPageProps extends NSARouterMakerResult, SchedulerRouterProps { }

class SchedulerListPage extends Component<SchedulerListPageProps>
{
    override render()
    {
        return (
            <SchedulerLayout
                {...this.props}
                pages={{
                    entity: SchedulerEntities.scheduler(this.props),
                    list: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Upcoming Runs",
                                                clicked: true,
                                                isVisible: () => true,
                                                getContent: ({ row }) => row ? <UpcomintRuns {...this.props} getRow={() => row} /> : <></>
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    },
                }}
            >
                <></>
            </SchedulerLayout>
        )
    }
}

export default SchedulerListPage;